import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import * as PropTypes from "prop-types";
import { block } from "../../../core";
export var Panel =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Panel, _React$PureComponent);

  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Panel).call(this, props));
    _this.state = {
      collapsed: props.defaultCollapsed
    };
    return _this;
  }

  _createClass(Panel, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.defaultCollapsed != this.props.defaultCollapsed) {
        this.setState({
          collapsed: nextProps.defaultCollapsed
        });
      }
    }
  }, {
    key: "toggleCollapsed",
    value: function toggleCollapsed() {
      this.setState({
        collapsed: !this.state.collapsed
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          mod = _this$props.mod,
          className = _this$props.className,
          disabled = _this$props.disabled,
          children = _this$props.children,
          collapsable = _this$props.collapsable;
      var collapsed = collapsable && this.state.collapsed;
      var containerBlock = block(mod).state({
        disabled: disabled
      });
      var titleDiv;

      if (collapsable) {
        titleDiv = React.createElement("div", {
          className: containerBlock.el("header").state({
            collapsable: collapsable,
            collapsed: collapsed
          }),
          onClick: this.toggleCollapsed.bind(this)
        }, title);
      } else {
        titleDiv = React.createElement("div", {
          className: containerBlock.el("header")
        }, title);
      }

      return React.createElement("div", {
        className: containerBlock.mix(className)
      }, titleDiv, React.createElement("div", {
        className: containerBlock.el("content").state({
          collapsed: collapsed
        })
      }, children));
    }
  }]);

  return Panel;
}(React.PureComponent);
Panel.propTypes = {
  title: PropTypes.string,
  disabled: PropTypes.bool,
  mod: PropTypes.string,
  className: PropTypes.string,
  collapsable: PropTypes.bool,
  defaultCollapsed: PropTypes.bool
};
Panel.defaultProps = {
  disabled: false,
  collapsable: false,
  defaultCollapsed: true,
  mod: "sk-panel"
};